import React from "react";
import PropTypes from "prop-types";
import { ExtensionTwoColumnLayout } from "../../../components/Preview/catalog-product";
import styles from "./PostPurchaseProductSection.module.css";

export default function PostPurchaseProductSection({
  popupData,
  section,
  activeStep,
  index,
  footerContent = null,
}) {
  return (
    <div className={styles.card}>
      <span className={styles.badge}>Product</span>
      <div className={styles.body}>
        <ExtensionTwoColumnLayout
          popupData={popupData}
          section={section}
          activeStep={activeStep}
          parentIndex={index}
          footerContent={footerContent}
        />
      </div>
    </div>
  );
}

PostPurchaseProductSection.propTypes = {
  popupData: PropTypes.object,
  section: PropTypes.object,
  activeStep: PropTypes.number,
  index: PropTypes.number,
  footerContent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};
